import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../ui/table';
import { ResponseTimeStats as ResponseTimeStatsType } from '../../types';
import { formatResponseTime, formatNumber } from '../../constants/nginx-sites';
import { cn } from '../../lib/utils';

interface ResponseTimeStatsProps {
  data: ResponseTimeStatsType;
}

export function ResponseTimeStats({ data }: ResponseTimeStatsProps) {
  const p95Color =
    data.p95 < 0.5
      ? 'text-green-600 dark:text-green-400'
      : data.p95 < 2
        ? 'text-amber-500 dark:text-amber-400'
        : 'text-red-600 dark:text-red-400';

  return (
    <div className="space-y-4">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <Card>
          <CardContent className="pt-4 pb-4">
            <p className="text-xs font-medium text-muted-foreground mb-1">Tempo Médio</p>
            <p className="text-2xl font-bold">{formatResponseTime(data.avg)}</p>
          </CardContent>
        </Card>
        <Card>
          <CardContent className="pt-4 pb-4">
            <p className="text-xs font-medium text-muted-foreground mb-1">Mediana (P50)</p>
            <p className="text-2xl font-semibold">{formatResponseTime(data.p50)}</p>
          </CardContent>
        </Card>
        <Card>
          <CardContent className="pt-4 pb-4">
            <p className="text-xs font-medium text-muted-foreground mb-1">P95</p>
            <p className={cn('text-2xl font-semibold', p95Color)}>{formatResponseTime(data.p95)}</p>
          </CardContent>
        </Card>
        <Card>
          <CardContent className="pt-4 pb-4">
            <p className="text-xs font-medium text-muted-foreground mb-1">P99</p>
            <p className="text-2xl font-semibold">{formatResponseTime(data.p99)}</p>
          </CardContent>
        </Card>
      </div>

      {data.slowRequests && data.slowRequests.length > 0 && (
        <Card>
          <CardHeader>
            <CardTitle>Requisições Mais Lentas</CardTitle>
          </CardHeader>
          <CardContent>
            <Table>
              <TableHeader>
                <TableRow>
                  <TableHead>Caminho</TableHead>
                  <TableHead className="text-right">Tempo Médio</TableHead>
                  <TableHead className="text-right">Requisições</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {data.slowRequests.map((req) => (
                  <TableRow key={req.path}>
                    <TableCell className="font-mono text-xs">{req.path}</TableCell>
                    <TableCell className="text-right">{formatResponseTime(req.avgTime)}</TableCell>
                    <TableCell className="text-right">{formatNumber(req.count)}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </CardContent>
        </Card>
      )}
    </div>
  );
}
